import DetailService from '../../components/DetailService';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

function IntelligenceArtificielle() {
    return (
         <div>
           <Header/>
        <DetailService
            titre="Intelligence artificielle et algorithmie"
            categorie="Ingénierie"
            image="/images/ingenierie.avif"
            description="Nous maîtrisons les concepts et technologies de l’IA, ce qui nous permet d’intégrer efficacement ce domaine dans vos projets. Nous concevons également des chatbots et des interfaces IA pour enrichir l’expérience utilisateur. Grâce à notre expertise en algorithmie, nous développons des solutions sur mesure, optimisant vos processus internes et facilitant la prise de décision automatisée."
            etapes={[
                {
                    numero: 1,
                    titre: 'Cadrage du besoin',
                    texte: 'Identification du problème à résoudre, des données disponibles et des objectifs mesurables. Nous définissons ensemble le type de solution IA le mieux adapté à votre contexte.',
                },
                {
                    numero: 2,
                    titre: 'Collecte et préparation des données',
                    texte: 'Analyse, nettoyage et structuration des données nécessaires à l\'entraînement du modèle. Cette étape est cruciale pour garantir la qualité et la fiabilité des résultats.',
                },
                {
                    numero: 3,
                    titre: 'Développement et entraînement du modèle',
                    texte: 'Conception et entraînement de l\'algorithme ou du modèle IA selon les objectifs définis. Plusieurs approches sont testées et comparées pour retenir la plus performante.',
                },
                {
                    numero: 4,
                    titre: 'Évaluation et ajustements',
                    texte: 'Mesure des performances du modèle sur des données de test, identification des biais et des erreurs, puis ajustements itératifs pour atteindre le niveau de qualité attendu.',
                },
                {
                    numero: 5,
                    titre: 'Intégration et livraison',
                    texte: 'Déploiement de la solution dans votre environnement, documentation technique et accompagnement à la prise en main. Une phase de suivi post-livraison peut être prévue.',
                },
            ]}
            realisations={[
              
            ]}
        />
         <Footer/>
        </div>
    );
}

export default IntelligenceArtificielle;
